module.exports = __webpack_public_path__ + "img/story_link.af928645.png";